import React from "react";
import {
  GridCallbackDetails,
  GridPaginationModel,
  GridSortModel,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { PagedResponse } from "../types/Result";

export default function useDataGridPaging<T>(
  page: PagedResponse<T>,
  basePage: string
) {
  const navigate = useNavigate();
  const handlePaginationModelChange = (model: GridPaginationModel) => {
    let path = `/${basePage}?pageNumber=${model.page + 1}&pageSize=${
      model.pageSize
    }`;
    if (page.sort) {
      path += `&sort.sort=${page.sort.sort}&sort.field=${page.sort.field}`;
    }
    navigate(path);
  };
  const handleSortModelChange = (
    model: GridSortModel,
    details: GridCallbackDetails
  ) => {
    const sort = model[0];
    let path = `/${basePage}?pageNumber=${page.currentPage}&pageSize=${page.pageSize}`;
    if (sort) {
      path += `&sort.sort=${sort.sort}&sort.field=${sort.field}`;
    }
    navigate(path);
  };
  const paginationModel: GridPaginationModel = React.useMemo(
    () => ({
      page: page.currentPage,
      pageSize: page.pageSize,
    }),
    [page.currentPage, page.pageSize]
  );
  const sortModel: GridSortModel = React.useMemo(
    () => (page.sort ? [{ field: page.sort.field, sort: page.sort.sort }] : []),
    [page.sort]
  );

  return {
    handlePaginationModelChange,
    handleSortModelChange,
    paginationModel,
    sortModel,
  };
}
